export const getCurrentCountry = () => process.env.REACT_APP_DEFAULT_LOCALE;
